import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    .corwin-layout-default {
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        minmax(0, auto)
        var(--block-bottom-padding)
        [last-line];
      max-width: 100%;

      .details {
        grid-column: 2 / 8;
        grid-row: 3;
      }

      .image img {
        max-width: 100%;
      }

      .details > .header {
        margin-top: calc(var(--top-padding-height) - 15px);
        margin-bottom: var(--text-stack-header-gap);
      }
    }

    .corwin-layout-column {
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        minmax(0, auto)
        var(--block-bottom-padding)
        [last-line];
      max-width: 100%;

      .details {
        grid-column: 2 / 8;
        grid-row: 3;
      }

      .image img {
        width: 100%;
      }

      .details > .header {
        margin-top: calc(30rem / var(--default-rem-px-count));
        margin-bottom: var(--text-stack-header-gap);
      }
    }

    .description {
      margin-bottom: var(--text-stack-cta-gap);
    }

    .cta-list {
      grid-column: 5 / 8;
      grid-row: 3;
      place-self: start end;

      display: flex;
      flex-direction: column;
      gap: calc(20rem / var(--default-rem-px-count));
    }

    .image {
      grid-column: 2 / 8;
      grid-row: 2;
    }

    .video {
      grid-column: 2 / 8;
      grid-row: 2;
      width: 100%;
      position: relative;
    }

    /* The cluster styles itself; only the offset below the media is ours. */
    image-caption {
      margin-top: calc(14rem / var(--default-rem-px-count));
    }

    @media (min-width: 600px) {
      .corwin-layout-default > .details > .header {
        margin-bottom: var(--top-padding-height);
      }

      .description {
        margin-bottom: calc(30rem / var(--default-rem-px-count));
      }

      .corwin-layout-default {
        grid-template-rows:
          var(--block-top-padding)
          minmax(0, auto)
          minmax(0, auto)
          var(--block-bottom-padding)
          [last-line];
        max-width: 100%;

        .details {
          grid-column: 2 / 6;
          grid-row: 2;
        }

        .video,
        .image {
          grid-column: 7 / 14;
          grid-row: 2;
        }

        .cta-list {
          grid-column: 2 / 6;
          place-self: normal left;
          width: calc(220rem / var(--default-rem-px-count));
        }
      }

      .corwin-layout-column {
        grid-template-rows:
          var(--block-top-padding)
          minmax(0, auto)
          minmax(0, auto)
          minmax(0, auto)
          minmax(0, auto)
          var(--block-bottom-padding)
          [last-line];
        width: 100%;
        max-width: 100%;

        .details {
          /* allows the grandchildren to use the css grid established by their
          parent's parent */
          display: contents;

          .header {
            grid-column: 2 / 14;
            grid-row: 2;
            margin: calc(30rem / var(--default-rem-px-count)) auto;
          }
          .description {
            grid-column: 5 / 11;
            grid-row: 3;
            text-align: center;
          }
          .cta-list {
            grid-column: 12 / 14;
            grid-row: 3;
          }
        }

        .video,
        .image {
          grid-column: 2 / 14;
          grid-row: 4;
          margin-bottom: calc(30rem / var(--default-rem-px-count));
        }
      }
    }
  `,
];
